<div class="layout-container">
  <div class="page-not-found">  
    <div class="page-not-found-image">
      <img src="/assets/imgs/not-found/not-found.png" alt="Page not found">
    </div>

    <div class="page-not-found-description">  
      <h1>Parece que algo deu errado :(</h1>

      <p>Não temos ideia de como você veio parar aqui.</p>

      <p>Talvez você tenha se perdido através de um link desatualizado, ou de um erro de digitação.</p>

    </div>  
  </div>
</div>
  